import React from 'react';
import VerifiedIcon from '@mui/icons-material/Verified';
import PublicIcon from '@mui/icons-material/Public';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const VALUES = [
  { title: 'Total Satisfaction', sub: '100% Guaranteed', desc: 'Committed to exceeding expectations with every order for healthcare professionals across Africa.', icon: <VerifiedIcon fontSize="large" /> },
  { title: 'Competitive Price', sub: 'Low price, total quality', desc: 'Over 3,000 quality medical items at highly competitive prices without compromising CE or FDA standards.', icon: <WorkspacePremiumIcon fontSize="large" /> },
  { title: 'Dedicated Service', sub: 'Expert Support', desc: 'Our team supports hospitals and laboratories with expert guidance and fast delivery across the continent.', icon: <PublicIcon fontSize="large" /> },
];

const HomeValues: React.FC = () => (
  <section className="py-12 sm:py-20 bg-light">
    <div className="container-main grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
      {VALUES.map(val => (
        <div key={val.title} className="card p-6 sm:p-8 text-center bg-white shadow-sm border border-gray-100">
          <div className="text-primary mb-4">{val.icon}</div>
          <h3 className="text-lg sm:text-xl font-bold text-primary mb-1">{val.title}</h3>
          <p className="text-primary/60 font-medium text-sm mb-4">{val.sub}</p>
          <p className="text-gray-500 text-sm leading-relaxed">{val.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HomeValues;
